var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "RichEditor",
      attrs: {
        Designer: "RichEditor",
        contenteditable: "false",
        ControlId: _vm.ControlId
      },
      on: { click: _vm.OnClick }
    },
    [
      _c("div", {
        ref: "EditingArea",
        attrs: {
          contenteditable:
            _vm.$props.Editable == null || _vm.$props.Editable == true,
          Name: "RichEditorEditingArea"
        },
        domProps: { innerHTML: _vm._s(_vm.m_BrowserHtml) },
        on: {
          change: function($event) {
            return _vm.OnChange($event)
          },
          input: function($event) {
            return _vm.OnInput($event)
          },
          blur: function($event) {
            return _vm.OnBlur($event)
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }